<template>
<v-card
    min-width="320"
    class="primary fill-height rounded-0 d-flex flex-column justify-space-between"
    style="padding: 35px; min-height: 850px;">
    <TwoLineCell
      firstLine="Nome do Beneficiário"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="formatter.capitalizeText(beneficiary.insuredName)"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="CPF"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="beneficiary.insuredDocumentNumber ? formatter.formatCpf(beneficiary.insuredDocumentNumber.toString()) : '—'"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Idade"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="`${beneficiary.insuredAge} anos` || '—'"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Data de nascimento"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="formatter.formatDate(beneficiary.birthDate) || '—'"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Parentesco"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="formatter.capitalizeText(beneficiary.kinshipName)"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Nome do Titular"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="formatter.capitalizeText(beneficiary.holderName)"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="CPF do Titular"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="beneficiary.holderDocumentNumber ? formatter.formatCpf(beneficiary.holderDocumentNumber.toString()) : '—'"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Operadora"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="beneficiary.carrierName"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Apólice"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="beneficiary.policy"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />

    <TwoLineCell
      firstLine="Subcontrato"
      :firstLineClass="requestFirstLine.class"
      :firstLineStyle="requestFirstLine.style"
      :secondLine="`${beneficiary.subcontractNumber} ${beneficiary.benefitType}`"
      :secondLineClass="requestSecondLine.class"
      :secondLineStyle="requestSecondLine.style"
    />
  </v-card>
</template>

<script>
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import Formatters from '@/shared/formatters/formatters';
import TwoLineCell from '@/components/Default/TwoLineCell.vue';
import { mapGetters } from 'vuex';

export default {
  name: "CoverageCard",

  components: {
    TwoLineCell,
  },

  data: () => ({
    formatter: null,
  }),

  mixins: [
    MajorityMixin,
  ],

  computed: {
    ...mapGetters({
      beneficiary: 'majority/beneficiary',
    }),
  },

  created() {
    this.formatter = new Formatters();
  },
}
</script>
